import sanitizeHtml from 'sanitize-html';

// Tags whose contents are parsed as raw text by HTML parsers. If they are not
// listed in `nonTextTags`, sanitize-html's `discard` path re-emits their inner
// content unescaped (GHSA on sanitize-html <= 2.17.3 via <xmp>).
const RAW_TEXT_PASSTHROUGH_TAGS = [
  'script',
  'style',
  'textarea',
  'option',
  'xmp',
  'noscript',
  'noembed',
  'noframes',
  'plaintext',
];

// Belt-and-suspenders: drop <xmp> wrappers before parsing so the bypass cannot
// land even if a caller passes nonTextTags that omits xmp.
const XMP_TAG = /<\/?xmp\b[^>]*>/gi;

export function safeSanitize(dirty, options = {}) {
  const input = typeof dirty === 'string' ? dirty.replace(XMP_TAG, '') : dirty;
  const merged = {
    ...options,
    nonTextTags: Array.from(
      new Set([...(options.nonTextTags || []), ...RAW_TEXT_PASSTHROUGH_TAGS]),
    ),
  };
  return sanitizeHtml(input, merged);
}

if (typeof window !== 'undefined') {
  window.sanitizeHtml = safeSanitize;
}

export default safeSanitize;
